define('util/calculus',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.getSlope = void 0;
    /**
     * Linear least squares fitting
     */
    function getSlope(points, getX, getY) {
        var sumx = 0;
        var sumy = 0;
        var sumxx = 0;
        var sumxy = 0;
        // tslint:disable-next-line:prefer-for-of
        for (var i = 0; i < points.length; i++) {
            var point = points[i];
            var x = getX(point);
            var y = getY(point);
            sumx += x;
            sumy += y;
            sumxx += x * x;
            sumxy += x * y;
        }
        var n = points.length;
        return (sumxy - sumx * sumy / n) / (sumxx - sumx * sumx / n);
    }
    exports.getSlope = getSlope;
});
//# sourceMappingURL=/assets/javascripts/util/calculus.js.map;
